import { Box, Step, StepConnector, StepIconProps, StepLabel, Stepper } from '@mui/material';
import { makeStyles, withStyles } from 'tss-react/mui';
import { DescriptionOutlined, PersonOutline } from '@mui/icons-material';
import { ROUTING_CONFIG } from '@uplift/constants';
import { Key } from '@uplift/icons';
import React from 'react';

const AcctStepConnector = withStyles(StepConnector, (theme, _params, classes) => ({
  alternativeLabel: {
    top: '24px',
    left: 'calc(-50% + 36px)',
    right: 'calc(50% + 36px)',
    [theme.breakpoints.up('sm')]: {
      top: '28px',
    }
  },
  active: {
    [`& .${classes.line}`]: {
      borderColor: theme.palette.secondary.border
    }
  },
  line: {
    height: '1px'
  }
}));

const Label = withStyles(StepLabel, theme => ({
  label: {
    color: theme.palette.text.primary,
  },
  labelContainer: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block'
    }
  },
}));

export const StepIcon: React.VFC<StepIconProps> = props => {
  const { classes, cx } = useStyles();
  const icons = {
    1: <Key />,
    2: <PersonOutline />,
    3: <DescriptionOutlined />
  };

  return (
    <div
      className={cx(classes.icon, {
        [classes.active]: props.active,
        [classes.complete]: props.completed
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
};

export type StepperProps = {
  step: string;
};

export const AcctStepper: React.VFC<StepperProps> = props => {
  const { classes } = useStyles();
  const step = {
    [ROUTING_CONFIG.onboardingInvite]: 0,
    [ROUTING_CONFIG.onboardingGeneral]: 1,
    [ROUTING_CONFIG.onboardingPayorEnrollment]: 2,
  }[props.step];

  return (
    <Box className={classes.wrapper}>
      <Stepper
        alternativeLabel
        activeStep={step}
        className={classes.content}
        connector={<AcctStepConnector />}
      >
        <Step key={ROUTING_CONFIG.onboardingInvite}>
          <Label StepIconComponent={StepIcon}>
            Set Password
          </Label>
        </Step>
        <Step key={ROUTING_CONFIG.onboardingGeneral}>
          <Label StepIconComponent={StepIcon}>
            Add Account Details
          </Label>
        </Step>
        <Step key={ROUTING_CONFIG.onboardingPayorEnrollment}>
          <Label StepIconComponent={StepIcon}>
            Payer Enrollment
          </Label>
        </Step>
      </Stepper>
    </Box>
  );
};

const useStyles = makeStyles<void, 'active' | 'complete'>()((theme, _params, classes) => ({
  active: { },
  complete: { },
  content: {
    backgroundColor: 'unset',
    display: 'flex',
    justifyContent: 'center',
    margin: '0 auto',
    maxWidth: '596px',
    padding: theme.spacing(2, 5),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(3),
    }
  },
  icon: {
    alignItems: 'center',
    border: `1.5px solid ${theme.palette.text.disabled}`,
    borderRadius: '50%',
    color: theme.palette.text.secondary,
    display: 'flex',
    height: '48px',
    justifyContent: 'center',
    width: '48px',
    [`&.${classes.active}`]: {
      background: theme.palette.secondary.background,
      border: `1.5px solid ${theme.palette.secondary.main}`,
      borderRadius: '50%',
      color: theme.palette.secondary.main
    },
    [`&.${classes.complete}`]: {
      background: theme.palette.secondary.background,
      border: `1px solid ${theme.palette.secondary.border}`,
      borderRadius: '50%',
      color: theme.palette.secondary.main
    },
    [theme.breakpoints.up('sm')]: {
      height: '56px',
      width: '56px',
    }
  },
  wrapper: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    boxSizing: 'border-box',
    height: '80px',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      height: '131px',
    }
  }
}));
